import { FormbrewError, isFormbrewError } from "@formbrew/js";
import { version as packageVersion } from "../package.json";
export { FormbrewError, isFormbrewError };
export type {
  FormbrewEmbedErrorDetail,
  FormbrewEmbedErrorPhase,
  FormbrewEmbedEventMap,
  FormbrewEmbedOptions,
  FormbrewEmbedReadyDetail,
  FormbrewEmbedSuccessDetail,
  FormbrewFormElement,
  FormbrewGlobal,
} from "./embed.types.ts";
export { render } from "./render.ts";

export const version = packageVersion;
